<div class="col-md-12">
    <div class="row p-5 border-bottom" *ngIf="isModal">
        <div class="col">
            <h4>Create Line Number Format</h4>
        </div>
    </div>
</div>

<div class="col-md-12 custom-wrap px-5" [formGroup]="linerNumberFormatFormGroup">
    <div class="row mb-3 mt-3">
        <div class="col-md-8">
            <mat-label>Name</mat-label>
            <mat-form-field class="example-full-width custom-text-field" floatLabel="never">
                <input type="text" formControlName="name" placeholder="Name" matInput (keypress)="onKeyPress($event)" (paste)="onKeyPress($event)" />
            </mat-form-field>
            <span class="text-danger" *ngIf="linerNumberFormatFormGroup.get('name').hasError('duplicateName')">Name should be unique!</span>
        </div>
        <div class="col-md-2">
            <section class="example-section">
                <mat-checkbox formControlName="defaultCheck" class="example-margin checkbox-wrap">Default</mat-checkbox>
            </section>
            <span class="text-danger" *ngIf="linerNumberFormatFormGroup.get('defaultCheck').hasError('alreadyDefaultSelected')"
                >Already one default selected!</span
            >
            <span class="text-danger" *ngIf="linerNumberFormatFormGroup.get('defaultCheck').hasError('oneRequireDefaultSelected')"
                >One default select Required!</span
            >
        </div>
        <div class="col-md-2">
            <section class="example-section">
                <mat-checkbox formControlName="allowFreeCheck" class="example-margin checkbox-wrap">Allow Freeform?</mat-checkbox>
            </section>
        </div>
    </div>
    <div class="row mb-3 mt-3" *ngIf="getExampleFormControlArray()?.controls?.length">
        <div class="example-part">
            <p>Example</p>
            <div class="example-wrapper">
                <div *ngFor="let ex of getExampleFormControlArray()?.controls; let i = index">
                    <mat-form-field class="example-full-width custom-text-field line-divider" style="width: 125px; float: left; margin-right: 15px">
                        <input type="text" [formControl]="getExampleFormControlArray().controls[i]" matInput />
                    </mat-form-field>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="getSectionFormControlArray()?.controls?.length">
        <div class="col-md-11 section-tab">
            <mat-tab-group
                class="example-tab view-scroll"
                [(selectedIndex)]="selectedTabNo"
                (selectedTabChange)="tabChangeEvent($event)"
                [disablePagination]="pagination"
                animationDuration="0ms"
                #tab
            >
                <mat-tab formArrayName="section" *ngFor="let sections of _linenumberFormat?.sections; let i = index">
                    <ng-template mat-tab-label disabled>
                        Section {{ i + 1 }}
                        <mat-icon
                            class="example-tab-icon"
                            *ngIf="_linenumberFormat.sections.length !== 1"
                            (click)="deleteLineNumberSection(sections, getSectionFormControlArray().controls[i])"
                            >close</mat-icon
                        >
                    </ng-template>
                    <div
                        class="row"
                        style="margin: 15px auto"
                        [formGroup]="getSectionFormControlArray()?.controls[i]"
                        *ngIf="getSectionFormControlArray()?.controls[i]?.get('checkboxGroup')"
                    >
                        <div class="col-md-6 mb-3 mt-3">
                            <mat-label>Name</mat-label>
                            <mat-form-field class="example-full-width custom-text-field" floatLabel="never">
                                <input
                                    type="text"
                                    placeholder="Name"
                                    matInput
                                    formControlName="name"
                                    (keypress)="onKeyPress($event)"
                                    (paste)="onKeyPress($event)"
                                />
                            </mat-form-field>
                            <span class="text-danger" *ngIf="getSectionFormControlArray()?.controls[i]?.get('name').hasError('duplicateName')"
                                >Name should be unique!</span
                            >
                        </div>
                        <div
                            class="col-md-6 d-flex justify-content-center flex-column position-relative"
                            formGroupName="checkboxGroup"
                            *ngIf="getSectionFormControlArray()?.controls[i]?.get('checkboxGroup')"
                        >
                            <div class="d-flex">
                                <mat-checkbox
                                    class="example-margin pe-10 checkbox-wrap"
                                    (change)="
                                        updateLineFormatString(getSectionFormControlArray()?.controls[i], getExampleFormControlArray().controls[i], 'checkBox')
                                    "
                                    formControlName="allowAlpha"
                                    >Allow Alpha</mat-checkbox
                                >
                                <mat-checkbox
                                    class="example-margin checkbox-wrap"
                                    (change)="
                                        updateLineFormatString(getSectionFormControlArray()?.controls[i], getExampleFormControlArray()?.controls[i], 'checkBox')
                                    "
                                    formControlName="allowNumeric"
                                    >Allow Numeric</mat-checkbox
                                >
                            </div>
                            <div class="position-absolute checboxError">
                                <span
                                    class="text-danger"
                                    *ngIf="getSectionFormControlArray().controls[i]?.get('checkboxGroup')?.hasError('requireOneCheckboxToBeChecked')"
                                    >At least One Should be checked!</span
                                >
                            </div>
                        </div>
                        <div class="col-md-6 mb-3 mt-3" *ngIf="getSectionFormControlArray().controls[i].get('sectionType')">
                            <mat-label>Category</mat-label>
                            <mat-select
                                name="line_spec"
                                class="dropdown-wrapper"
                                panelClass="dropdown-wrapper"
                                [(value)]="sections.lineNumberFormatSectionTypeId"
                                formControlName="sectionType"
                                (selectionChange)="dropdownSelectionChange($event)"
                            >
                                <mat-option
                                    class="option-list"
                                    value="{{ sectionType.lineNumberFormatSectionTypeId }}"
                                    *ngFor="let sectionType of defaultLineNumberFormatSectionTypes"
                                >
                                    {{ sectionType.name }}</mat-option
                                >
                            </mat-select>
                        </div>
                        <div class="col-md-12 mb-3 mt-3" formGroupName="minMaxGroup" *ngIf="getSectionFormControlArray()?.controls[i]?.get('minMaxGroup')">
                            <div class="row">
                                <div class="col-md-6">
                                    <mat-label>Min Characters</mat-label>
                                    <mat-form-field class="example-full-width custom-text-field" floatLabel="never">
                                        <input
                                            type="number"
                                            placeholder="Min Chars"
                                            (input)="
                                                updateLineFormatString(
                                                    getSectionFormControlArray().controls[i],
                                                    getExampleFormControlArray().controls[i],
                                                    'input'
                                                )
                                            "
                                            formControlName="minChar"
                                            matInput
                                        />
                                    </mat-form-field>
                                   
                                    <span
                                        class="text-danger"
                                        *ngIf="getSectionFormControlArray().controls[i].get('minMaxGroup').get('minChar').hasError('min')"
                                    >
                                        Minimum possible value is 
                                        <strong> {{ getSectionFormControlArray().controls[i].get('minMaxGroup').get('minChar').errors.min.min }}</strong
                                        >!
                                    </span>
                                    <span
                                        class="text-danger"
                                        *ngIf="getSectionFormControlArray().controls[i].get('minMaxGroup').get('minChar').hasError('max')"
                                    >
                                        Maximum possible value is
                                        <strong> {{ getSectionFormControlArray().controls[i].get('minMaxGroup').get('minChar').errors.max.max }}</strong
                                        >!
                                    </span>
                                </div>
                                <div class="col-md-6">
                                    <mat-label>Max Characters</mat-label>
                                    <mat-form-field class="example-full-width custom-text-field" floatLabel="never">
                                        <input
                                            type="number"
                                            placeholder="Max Chars"
                                            (input)="
                                                updateLineFormatString(
                                                    getSectionFormControlArray().controls[i],
                                                    getExampleFormControlArray().controls[i],
                                                    'input'
                                                )
                                            "
                                            formControlName="maxChar"
                                            matInput
                                        />
                                    </mat-form-field>
                                    <span
                                        class="text-danger"
                                        *ngIf="getSectionFormControlArray().controls[i].get('minMaxGroup').get('maxChar').hasError('max')"
                                    >
                                        Maximum possible value is
                                        <strong> {{ getSectionFormControlArray().controls[i].get('minMaxGroup').get('maxChar').errors.max.max }}</strong
                                        >!
                                    </span>
                                    <span
                                        class="text-danger"
                                        *ngIf="getSectionFormControlArray().controls[i].get('minMaxGroup').get('maxChar').hasError('min')"
                                    >
                                        Minimum possible value is {{isZeroCharacterAllowed |json}}
                                        <strong> {{ getSectionFormControlArray().controls[i].get('minMaxGroup').get('maxChar').errors.min.min }}</strong
                                        >!
                                    </span>
                                </div>
                            </div>
                            <span class="text-danger" *ngIf="getSectionFormControlArray().controls[i].get('minMaxGroup').hasError('inValidMinMaxValue')">
                                Invalid value for minimum and maximum characters!
                            </span>
                        </div>
                       
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
        <div class="col-md-1">
            <button
                class="btn primary-ebtn"
                [disabled]="!linerNumberFormatFormGroup.get('section').valid || getSectionFormControlArray().controls.length >= 10"
                (click)="addNewLineNumberSection()"
            >
                <i class="fa fa-plus p-0"></i>
            </button>
        </div>
    </div>
</div>
